import { Navbar } from "@/components/site/Navbar";
import { ScrollCinematicHero } from "@/components/site/ScrollCinematicHero";
import { Profile } from "@/components/site/Profile";
import { Engagements } from "@/components/site/Engagements";
import { Approach } from "@/components/site/Approach";
import { Ethos } from "@/components/site/Ethos";
import { Publications } from "@/components/site/Publications";
import { Contact } from "@/components/site/Contact";
import "@/styles/landing.css";

export default function LandingPage() {
  return (
    <div className="landing-root bg-ink text-sand min-h-screen" data-testid="landing-page">
      <Navbar />
      <main>
        <ScrollCinematicHero />
        <Profile />
        <Engagements />
        <Approach />
        <Ethos />
        <Publications />
        <Contact />
      </main>
    </div>
  );
}
